import React from 'react';
import { Sidebar } from './Sidebar';

export const AdminLayout = ({ children }) => {
  return (
    <div className="flex h-screen" style={{ background: 'var(--bg-primary)' }}>
      <Sidebar />
      <main className="flex-1 p-8 overflow-y-auto">
        {children}
      </main>
    </div>
  );
};